<!--
  TODO: remove this component after we have real live example somewhere
-->
<svelte:options
  customElement={{
    tag: "oc-test-component",
    props: {
      mystring: { type: "String", reflect: true },
      mynum: { type: "Number", reflect: true },
      myboolean: { type: "Boolean", reflect: true },
      myobject: { type: "Object", reflect: true },
      myarray: { type: "Array", reflect: true },
      // not allowed
      // myfunction: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { usePropertyChange } from "../../common/utils/usePropertyChange";

  export let mystring: string = "";
  export let mynum: number = 0;
  export let myboolean: boolean = false;
  export let myobject: { date: Date } = { date: new Date() };
  export let myarray: string[] = [];

  usePropertyChange();

  const dispatch = createEventDispatcher<{
    "something-happens": { foo: "bar" };
  }>();

  dispatch("something-happens", { foo: "bar" });
</script>

<input type="text" bind:value={mystring} />
<!-- bind:value statt value was anderes damit erst beim rausfokussieren das event gefeuert wird  -->
<!-- <input type="text" bind:value={mystring} /> -->
<input type="number" bind:value={mynum} />
<input type="checkbox" bind:checked={myboolean} />

<button
  on:click={() => {
    myobject = { date: new Date() };
  }}>Neuzuweisen Object</button
>

<button
  on:click={() => {
    myobject.date = new Date();
  }}>Manipulieren Object</button
>

<button
  on:click={() => {
    myarray = [...myarray, "foo"];
  }}>Neuzuweisen Array</button
>

<button
  on:click={() => {
    myarray.push("foo");
  }}>Manipulieren Array</button
>
